import Home from '../components/Home'
import Products from '../components/Products/Products'
import Product from '../components/Products/Product'
import ProductList from '../components/Products/ProductList'
import ProductView from '../components/Products/ProductView'
import ProductForm from '../components/Products/ProductForm'
import FwUpdate from '../components/FwUpdates/FwUpdate'
import FwUpdateForm from '../components/FwUpdates/FwUpdateForm'
import FwUpdateList from '../components/FwUpdates/FwUpdateList'
import Things from '../components/Things/Things'
import Thing from '../components/Things/Thing'
import ThingList from '../components/Things/ThingList'
import ThingView from '../components/Things/ThingView'
import ThingForm from '../components/Things/ThingForm'
import Clients from '../components/Clients/Clients'
import Client from '../components/Clients/Client'
import ClientList from '../components/Clients/ClientList'
import ClientView from '../components/Clients/ClientView'
import ClientForm from '../components/Clients/ClientForm'
import DeviceList from '../components/Devices/DeviceList'
import Users from '../components/Users/Users'
import User from '../components/Users/User'
import UserList from '../components/Users/UserList'
import UserView from '../components/Users/UserView'
import UserForm from '../components/Users/UserForm'
import ErrorPage from '../components/ErrorPage'

module.exports = [
  { path: '/', component: Home },
  { path: '/users',
    component: Users,
    children: [
      { path: '', component: UserList },
      {
        path: ':user_id(\\d+)',
        component: User,
        children: [
          { path: '', component: UserView },
          { path: 'edit', component: UserForm, props: {update: true} }
        ]
      }
    ]
  },
  { path: '/clients',
    component: Clients,
    children: [
      { path: '', component: ClientList },
      { path: 'create', component: ClientForm, props: {update: false} },
      {
        path: ':client_id(\\d+)',
        component: Client,
        children: [
          { path: '', component: ClientView },
          { path: 'edit', component: ClientForm, props: {update: true} },
          { path: 'devices', component: DeviceList }
        ]
      }
    ]
  },
  {
    path: '/products',
    component: Products,
    children: [
      { path: '', component: ProductList },
      { path: 'create', component: ProductForm, props: {update: false} },
      {
        path: ':product_id(\\d+)',
        component: Product,
        children: [
          { path: '', component: ProductView },
          { path: 'edit', component: ProductForm, props: {update: true} },
          {
            path: 'things',
            component: Things,
            children: [
              { path: '', component: ThingList },
              { path: 'create', component: ThingForm, props: {update: false} },
              {
                path: ':thing_id(\\d+)',
                component: Thing,
                children: [
                  { path: '', component: ThingView },
                  { path: 'edit', component: ThingForm, props: {update: true} }
                ]
              }
            ]
          },
          { path: 'fw_updates',
            component: FwUpdate,
            children: [
              { path: '', component: FwUpdateList },
              { path: 'create', component: FwUpdateForm }
            ]
          }
        ]
      }
    ]
  },
  { path: '*', components: {fullscreen: ErrorPage} }
]



// WEBPACK FOOTER //
// ./src/modules/routes.js